import React from "react";
import { SlDiamond } from "react-icons/sl";
import { useEffect,useState } from "react";
import { motion } from "framer-motion";
import { IoPersonSharp } from "react-icons/io5";
import anonymousPerson from '../../../assets/images/anonymous.jpg'
export default function LeaderCardList({ items }) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 1024);
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
      }, []);



  return (
    <div className="w-full">

    {

        isMobile ?
        <div className="w-full  overflow-x-auto relative">
            <motion.div
                className="flex gap-6 snap-mandatory"
                animate={{ x: ["0%", "50%"] }} 
                transition={{ repeat: Infinity, duration: 20, ease: "linear" }}
            >
                {items.concat(items).map((item, idx) => (
                <div key={idx} className="flex-shrink-0 w-[200px] lg:w-[280px] h-max py-5 snap-start">
                    <Card {...item} />
                </div>
                ))}
            </motion.div>
        </div>
        :
            <div className="hidden md:flex flex-wrap justify-center lg:gap-20 lg:px-20 px-3">
                {items.map((item, idx) => (
                <Card key={idx} {...item} />
                ))}
        </div>


    }
   
    </div>
  );
}

function Card({ icon, title, desc }) {
  return (

    <div className="rounded-[20px] hover:scale-105 transition-transform duration-300 text-special 
      lg:h-[317px] lg:w-[280px] w-[200px] h-[290px] bg-[#F2F5FB] shadow-md flex flex-col justify-between items-center px-6 lg:px-10 py-6 lg:py-10 border border-gray-200">
      
      <div className="flex justify-center rounded-full bg-white lg:w-[170px] lg:h-[170px] w-[150px] h-[150px]">
            {
                icon?
                <img className="w-full object-contain"></img>
                :
                <img className="w-full object-cover rounded-full"  src={anonymousPerson}></img>
               
            }
      </div>
      <p className="text-center my-3 text-[16px] lg:text-xl font-bold whitespace-normal">
        {title}
      </p>
      <div className="w-full mt-2">
        <p className="text-[13px] lg:text-sm text-center font-light whitespace-normal leading-relaxed">
          {desc}
        </p>
      </div>
    </div>
  );
}
